import { CALL_API, REQUEST_POST } from '../middleware/api'
import { UNARCHIVE_STUDY_REQUEST } from '../schemas'
import { ERROR, SUCCESS } from '../components/AlertListItem'
export const CREATE_UNARCHIVE_STUDY_REQUEST_REQUEST =
  'tru/unarchiveStudyRequests/CREATE_UNARCHIVE_STUDY_REQUEST_REQUEST'
export const CREATE_UNARCHIVE_STUDY_REQUEST_SUCCEEDED =
  'tru/unarchivedStudyRequests/CREATE_UNARCHIVE_STUDY_REQUEST_SUCCEEDED'
export const CREATE_UNARCHIVE_STUDY_REQUEST_FAILED =
  'tru/unarchivedStudyRequests/CREATE_UNARCHIVE_STUDY_REQUEST_FAILED'

export const createUnarchiveStudyRequest = archivedStudyId => ({
  [CREATE_UNARCHIVE_STUDY_REQUEST_FAILED]: error => ({
    alert: {
      type: ERROR,
      message: error.error[0],
      scope: 'createUnarchiveStudyRequestError'
    }
  }),
  [CREATE_UNARCHIVE_STUDY_REQUEST_SUCCEEDED]: {
    alert: {
      type: SUCCESS,
      message: 'Study scheduled for unarchiving',
      scope: 'createUnarchiveStudyRequestSuccess'
    }
  },
  [CALL_API]: {
    types: [
      CREATE_UNARCHIVE_STUDY_REQUEST_REQUEST,
      CREATE_UNARCHIVE_STUDY_REQUEST_SUCCEEDED,
      CREATE_UNARCHIVE_STUDY_REQUEST_FAILED
    ],
    endpoint: 'unarchive_study_requests.json',
    requestType: REQUEST_POST,
    data: { archivedStudyId },
    dataGetter: data => data.unarchiveStudyRequest,
    schema: UNARCHIVE_STUDY_REQUEST
  }
})



// WEBPACK FOOTER //
// ../src/actions/unarchiveStudyRequestActions.js